import { GetLogsResponse } from '../../Model/Log';
import { LogRepository, LogParams } from '../Repositories/LogRepository';

export class GetLogsUseCase {
  constructor(private repo: LogRepository) {}
  execute(params?: LogParams): Promise<GetLogsResponse> {
    return this.repo.getLogs(params).then(r => r).catch(err => Promise.reject(err));
  }
}
